import "../../../App.css";
import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Layout,
  message,
  Modal,
  Radio,
  Result,
} from "antd";
import "antd/dist/reset.css";
import useAxios from "axios-hooks";
import { CheckoutSubmissionRequest } from "../../../types/CheckoutSubmissionRequest";
import { useOrderId } from "../../../hooks/UseOrderId";
import { PaymentType } from "../../../App";
import { CardTypeEnum } from "../../../types/CardTypeEnum";
import { CheckoutStatusResult } from "../../../types/CheckoutStatusResult";
import { ProviderTypeEnum } from "../../../types/ProviderTypeEnum";
import WrappedCard from "../../antd/WrappedCard";
import easypaisaLogo from "../../../assets/easypaisa-logo.png";
import jazzcashLogo from "../../../assets/jazzcash-logo.png";
import "./PkDynamicWalletRequestFirstpayV2Mode.css";

const { Content } = Layout;

const ignore = false;
const OverdueTime = 3 * 60 * 1000;
const PollingTime = 5 * 1000;

// NOTICE: GET目前是同步的，后面有可能会需要支援非同步，近来收银台后先转圈等到GET有结果
function PkDynamicWalletRequestV7Mode({ getCheckoutInfoData }: PaymentType) {
  const id = useOrderId();

  const [{ data: putData }, executePost] = useAxios<CheckoutSubmissionRequest>(
    {
      url: `/v2/checkout/${id}`,
      method: "POST",
    },
    { manual: true }
  );
  console.log("[POST] checkout.putData", putData);

  const [
    { data: getCheckoutResultData, loading: pollingLoading },
    pollingCheckoutResult,
  ] = useAxios<CheckoutStatusResult>(`/v2/orders/${id}`);

  const [submitCheckout, setSubmitCheckout] = useState(
    getCheckoutInfoData?.checkoutStatus === "SUBMITTED"
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [providerName] = useState(
      getCheckoutInfoData?.defaultChannel === "easypaisa" ? CardTypeEnum.EasyPaisa :
          getCheckoutInfoData?.defaultChannel === "jazzcash" ? CardTypeEnum.JazzCash :
              getCheckoutInfoData?.defaultChannel === "jazzcash_v2" ? CardTypeEnum.JazzCashV2 :
                  getCheckoutInfoData?.defaultChannel === "ajar:easypaisa" ? CardTypeEnum.AjarToEasyPaisa :
                      getCheckoutInfoData?.defaultChannel === "ajar:jazzcash" ? CardTypeEnum.AjarToJazzCash :
                          null);
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [countDownText, setCountDownText] = useState("Ready countdown");
  const [neverCountDown, setNeverCountDown] = useState(true);
  const [showModal, setShowModal] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(getCheckoutInfoData?.automaticSubmission);

  const onFormFinish = (values: any) => {
    setSubmitCheckout(true);

    // NOTICE: 三分截止
    startOverdueCountDown();

    if (!ignore) {
      let newProviderName;
      let newReserved1;
      switch (values.providerName) {
        case CardTypeEnum.AjarToEasyPaisa:
          newProviderName = CardTypeEnum.Ajar;
          newReserved1 = CardTypeEnum.EasyPaisa;
          break;
        case CardTypeEnum.AjarToJazzCash:
          newProviderName = CardTypeEnum.Ajar;
          newReserved1 = CardTypeEnum.JazzCash;
          break;
        default:
          newProviderName = values.providerName;
          newReserved1 = null;
          break;
      }

      executePost({
        data: {
          id: id,
          providerType: ProviderTypeEnum.WALLET,
          providerName: newProviderName,
          customerAccount: values.customerAccount,
          customerIdCard: values.customerIdCard,
          reserved1: newReserved1,
          automaticSubmission:getCheckoutInfoData?.automaticSubmission
        },
      })
        .then(() => {
          setSubmitCheckout(true);
        })
        .catch((error) => {
          messageApi.error("Failed:" + error?.response?.data?.title);
        })
        .finally(() => {});
    }
  };

  const onButtonClick = () => {
    setIsSubmitting(true);
    form.submit();
  };

  const checkFormValidity = () => {
    form
      .validateFields()
      .then(() => {
        setIsFormValid(true);
      })
      .catch(() => {
        setIsFormValid(false);
      });
  };

  const [isOverdueTime, setIsOverdueTime] = useState<boolean>(false);
  console.log("0.isOverdueTime", isOverdueTime);

  // NOTICE: 十秒輪詢 way1
  useEffect(() => {
    const stoppingStatuses: string[] = ["SUCCESS", "FAIL"];

    let pollingCountDown: NodeJS.Timeout;
    if (isOverdueTime) {
      console.log(
        "[Polling] Cause overdue time , so no need to process to poll"
      );
    } else if (!submitCheckout) {
      checkFormValidity();
      console.log("[Polling] no need to process to poll");
    } else {
      console.log("[Polling] pollingLoading", pollingLoading);
      if (getCheckoutResultData?.status === "PROCESSING") {
        console.log("[Polling] restart to polling");
        if (neverCountDown) {
          setNeverCountDown(false);
          submitCountDown();
        }

        pollingCountDown = setTimeout(function () {
          pollingCheckoutResult()
            .then((data) => {
              console.log("[Polling] end to polling.data", data);
            })
            .catch((error) => {
              console.log("[Polling] restart to polling.error", error);
            })
            .finally(() => {});
        }, PollingTime);
      } else if (
        typeof getCheckoutResultData !== "undefined" &&
        stoppingStatuses.includes(getCheckoutResultData.status)
      ) {
        console.log("[Polling] end to polling.data", getCheckoutResultData);
        messageApi.info("Result: " + getCheckoutResultData.status);
      }
    }
    return () => {
      if (pollingCountDown) clearTimeout(pollingCountDown);
    };
  }, [submitCheckout, pollingLoading, isOverdueTime, getCheckoutResultData]);

  useEffect(() => {
    if (!submitCheckout && isSubmitted) {
      setIsSubmitted(false);
      onFormFinish({
        providerName: getCheckoutInfoData?.defaultChannel,
        customerAccount: getCheckoutInfoData?.receiverAccount,
        customerIdCard: getCheckoutInfoData?.receiverIdCard,
        customerName: getCheckoutInfoData?.receiverName,
      });
    }
  }, [isSubmitted]);

  // NOTICE: 三分截止
  let countDown: NodeJS.Timeout;
  const startOverdueCountDown = useCallback(() => {
    console.log("[CountDown] start to count down");
    countDown = setTimeout(function () {
      console.log("[CountDown] end to count down");
      setIsOverdueTime(true);
    }, OverdueTime);
  }, []);

  const clearOverdueCountDown = () => {
    clearTimeout(countDown);
  };
  useEffect(() => {
    return () => {
      clearOverdueCountDown();
    };
  });

  const submitCountDown = () => {
    let num = 120;
    setCountDownText(formatTime(num));
    let timer = setInterval(() => {
      num--;
      setCountDownText(formatTime(num));
      if (num === 0) {
        setCountDownText("Time's Up !!!");
        clearInterval(timer);
      }
    }, 1000);
  };

  const formatTime = (seconds: number) => {
    let minutes = Math.floor(seconds / 60);
    let remainingSeconds = seconds % 60;
    return `${padZero(minutes)}:${padZero(remainingSeconds)}`;
  };

  const padZero = (num: number) => {
    return num < 10 ? `0${num}` : `${num}`;
  };

  return (
    <div className="dwrf2-page">
      {contextHolder}

      {/*NOTICE: 訂單未完成*/}
      {getCheckoutInfoData?.checkoutStatus === "VISITED" && !submitCheckout && (
        <Content>
          {/*<Modal*/}
          {/*  open={showModal}*/}
          {/*  closable={false}*/}
          {/*  onOk={() => {*/}
          {/*    setShowModal(false);*/}
          {/*  }}*/}
          {/*  onCancel={() => {*/}
          {/*    setShowModal(false);*/}
          {/*  }}*/}
          {/*  okText="Confirm"*/}
          {/*>*/}
          {/*  <WrappedCard cardTitle="Important:">*/}
          {/*    <>*/}
          {/*      Please enter genuine & verifiable CNIC number and your wallet*/}
          {/*      account number & follow below steps. <br />*/}
          {/*      Step 1: Receive a notification for the transaction. <br />*/}
          {/*      Step 2: Open the EasyPaisa / JazzCash app and sign in. <br />*/}
          {/*      Step 3: Find the "Payment Requests" in JazzCash or "My*/}
          {/*      Approvals" in EasyPaisa. <br />*/}
          {/*      Step 4: Accept the transaction request.*/}
          {/*    </>*/}
          {/*  </WrappedCard>*/}

          {/*  <WrappedCard*/}
          {/*    cardTitle={*/}
          {/*      <>*/}
          {/*        <div*/}
          {/*          style={{*/}
          {/*            textAlign: "right",*/}
          {/*            width: "100%",*/}
          {/*            direction: "rtl",*/}
          {/*          }}*/}
          {/*        >*/}
          {/*          ضروری احکامات:*/}
          {/*        </div>*/}
          {/*      </>*/}
          {/*    }*/}
          {/*  >*/}
          {/*    <>*/}
          {/*      <div*/}
          {/*        style={{*/}
          {/*          textAlign: "right",*/}
          {/*          width: "100%",*/}
          {/*          direction: "rtl",*/}
          {/*        }}*/}
          {/*      >*/}
          {/*        تصدیق یافتہ شناختی کارڈ اور والٹ اکاؤنٹ درج کرنا ضروری ہے۔*/}
          {/*        <br />*/}
          {/*        اِس کے بعد نیچے دی گئی ہدایات پر عمل کریں*/}
          {/*        <br />*/}
          {/*        ۱۔ ٹرانزیکشن کا نوٹیفکیشن حاصل کریں۔*/}
          {/*        <br />*/}
          {/*        ۲۔ EasyPasia یا JazzCash کی ایپ کھولیں اور سائن ان کریں۔*/}
          {/*        <br />*/}
          {/*        ۳۔ آپ JazzCash کسٹمر ہیں تو "Payment Requests" اور EasyPaisa*/}
          {/*        کسٹمر ہیں تو "My Approvals" تلاش کریں۔*/}
          {/*        <br />*/}
          {/*        ۴۔ ٹرانزیکشن کی درخواست قبول کریں۔*/}
          {/*      </div>*/}
          {/*    </>*/}
          {/*  </WrappedCard>*/}
          {/*</Modal>*/}

          <WrappedCard cardProps={{ className: "dwrf2-payment-container" }}>
            <>
              {/*<div className="dwrf2-amount-title">TREND TACTIX</div>*/}

              <div className="dwrf2-amount-container">
                <div className="dwrf2-amount-content">
                  <div className="dwrf2-amount-currency">Amount (PKR)</div>
                  <div className="dwrf2-amount">
                    {getCheckoutInfoData?.orderAmount}
                  </div>
                </div>
              </div>
            </>

            <Form
              form={form}
              initialValues={{ providerName }}
              onFinish={onFormFinish}
              onChange={checkFormValidity}
            >
              <>
                <div className="dwrf2-form-container">
                  <div className="dwrf2-table-header">
                    <span>Select Channel</span>
                    <span>ادائیگی کی قسم منتخب کریں</span>
                  </div>
                  <Form.Item name="providerName" className="dwrf2-form-item">
                    <Radio.Group className="dwrf2-radio-group">
                      {getCheckoutInfoData?.availableChannels.includes(
                        "easypaisa"
                      ) && (
                        <Radio.Button
                          value={CardTypeEnum.EasyPaisa}
                          className="dwrf2-radio-button"
                        >
                          <img src={easypaisaLogo} alt="Easypaisa" />
                        </Radio.Button>
                      )}
                      {getCheckoutInfoData?.availableChannels.includes(
                        "jazzcash"
                      ) && (
                        <Radio.Button
                          value={CardTypeEnum.JazzCash}
                          className="dwrf2-radio-button"
                        >
                          <img src={jazzcashLogo} alt="Jazzcash" />
                        </Radio.Button>
                      )}
                      {getCheckoutInfoData?.availableChannels.includes(
                          "jazzcash_v2"
                      ) && (
                          <Radio.Button
                              value={CardTypeEnum.JazzCashV2}
                              className="dwrf2-radio-button"
                          >
                            <img src={jazzcashLogo} alt="Jazzcash" />
                          </Radio.Button>
                      )}
                      {getCheckoutInfoData?.availableChannels.includes(
                        "ajar:easypaisa"
                      ) && (
                        <Radio.Button
                          value={CardTypeEnum.AjarToEasyPaisa}
                          className="dwrf2-radio-button"
                        >
                          <img src={easypaisaLogo} alt="Easypaisa-a" />
                        </Radio.Button>
                      )}
                      {getCheckoutInfoData?.availableChannels.includes(
                        "ajar:jazzcash"
                      ) && (
                        <Radio.Button
                          value={CardTypeEnum.AjarToJazzCash}
                          className="dwrf2-radio-button"
                        >
                          <img src={jazzcashLogo} alt="Jazzcash-a" />
                        </Radio.Button>
                      )}
                    </Radio.Group>
                  </Form.Item>

                  <div className="dwrf2-input-container">
                    <div className="dwrf2-input-label">
                      <span>Wallet account number</span>
                      <span>والٹ اکاؤنٹ نمبر</span>
                    </div>
                    <Form.Item
                      name="customerAccount"
                      rules={[
                        {
                          required: true,
                          message:
                            "account should be an integer starting with 3 and totaling ten digits.",
                        },
                      ]}
                      initialValue={getCheckoutInfoData?.receiverAccount}
                    >
                      <Input className="dwrf2-input-field" />
                    </Form.Item>

                    <div className="dwrf2-input-label">
                      <span>CNIC</span>
                      <span>شناختی کارڈ</span>
                    </div>
                    <Form.Item
                      name="customerIdCard"
                      rules={[
                        {
                          required: true,
                          message:
                            "CNIC should be real CNIC number and thirteen digital integer.",
                        },
                      ]}
                      initialValue={getCheckoutInfoData?.receiverIdCard}
                    >
                      <Input className="dwrf2-input-field" />
                    </Form.Item>
                    <div className="dwrf2-transaction-fee">
                      <span>Transaction Fee</span>
                      <span>Free</span>
                    </div>
                    <Form.Item>
                      <div className="dwrf2-submit-button-container">
                        <Button
                          type="primary"
                          className="dwrf2-submit-button"
                          onClick={onButtonClick}
                          disabled={!isFormValid}
                        >
                          {isSubmitting ? "Paying..." : "Pay Now"}
                        </Button>
                      </div>
                    </Form.Item>
                    <Form.Item name="reserved1" style={{ display: "none" }}>
                      <Input />
                    </Form.Item>

                    <p className="dwrf2-footer-text">
                      After clicking "pay now", please open your wallet and
                      enter your password to complete the payment.
                      <br />
                      براہ کرم پے کا بٹن دبانے کے بعد اپنا والیٹ اکاؤنٹ کھولیں
                      پاسورڈ کے اندراج سے رقم کی ادائیگی مکمل کریں
                    </p>
                  </div>
                </div>
              </>
            </Form>
          </WrappedCard>
        </Content>
      )}

      {/*NOTICE: 使用者填寫完畢送出，會看到等待付款中狀態頁面。*/}
      {submitCheckout &&
        !isOverdueTime &&
        getCheckoutResultData?.status === "PROCESSING" && (
          <Result
            status="info"
            title={
              <>
                <div style={{ textAlign: "center", color: "red" }}>
                  Time Remaining
                  <br />
                  {countDownText}
                </div>
                <div>
                  Please open your wallet and approve the transaction now.
                  <br />
                  مہربانی فرما کر اپنا والٹ اکاؤنٹ کھولیں اور رقم کی ادائیگی
                  کریں
                </div>
              </>
            }
          />
        )}

      {/*NOTICE: 系統超過三分鐘後，使用者會看到訂單有問題之類訊息(後端之後會動態調整文案)。*/}
      {submitCheckout &&
        isOverdueTime &&
        getCheckoutResultData?.status === "PROCESSING" && (
          <Result
            status="warning"
            title="We have not received your payment yet. If the transaction is delayed, please reach out to customer service if there is no further progress within two hours."
          />
        )}
    </div>
  );
}

export default PkDynamicWalletRequestV7Mode;
